import { getMe, getMeInvoices } from '../services/users';
import { loadHome } from '../services/dashboard';

const centToReal = (amount) => (amount != null ? amount / 100 : 0);
const timestampToDate = (ts) => (ts ? new Date(ts * 1000).toISOString() : null);
const capitalize = (s) => s ? s.charAt(0).toUpperCase() + s.slice(1) : '';

const formatStripeAddress = (address) => {
    if (!address) return '';
    try {
        const parts = [];
        if (address.line1) parts.push(address.line1);
        if (address.line2) parts.push(address.line2);

        const cityState = [address.city, address.state].filter(Boolean).join(', ');
        if (cityState) parts.push(cityState);

        if (address.postal_code) parts.push(address.postal_code);

        return parts.join('\n');
    } catch (e) {
        console.error("Error on format address", e, address);
        return '';
    }
}

const invoiceStatusMap = {
    'open': 'pending',
    'paid': 'paid',
    'void': 'cancelled',
    'uncollectible': 'cancelled'
};

export const getSubscriptionDetails = async () => {
    const [meResponse, homeResponse] = await Promise.all([
        getMe(),
        loadHome()
    ]);

    const userData = meResponse.data;
    const homeData = homeResponse?.data;
    const { userSubscription, companySubscription } = userData;

    const limits = {
        agents: {
            current: homeData?.assistants?.value ?? 0,
            max: homeData?.assistants?.max ?? companySubscription?.planMaxAgents ?? 0
        },
        conversations: {
            current: homeData?.conversations?.value ?? 0,
            max: homeData?.conversations?.max ?? companySubscription?.planMaxConversations ?? 0
        }
    };

    const formattedData = {
        planName: companySubscription.planName || "Plano Indefinido",
        price: centToReal(companySubscription?.subscriptionPrice),
        renewalDate: timestampToDate(companySubscription?.subscriptionRenewsOn),
        cancelAt: companySubscription?.subscriptionCancelAt,
        canceledAt: companySubscription?.subscriptionCanceledAt,
        features: companySubscription?.subscriptionplanFeatures || [],
        subscriptionStatus: companySubscription?.subscriptionStatus || 'inactive',
        limits: limits,
        billing: {
            cardType: capitalize(companySubscription?.billingCardBrand) || 'N/A',
            last4: companySubscription?.billingCardLast4 || '****',
            name: companySubscription?.billingName || 'N/A',
            address: formatStripeAddress(companySubscription?.billingAddress)
        },
        userRole: userData.user.role || 'editor'
    };

    return { data: formattedData, home: homeResponse.data };
}

export const getInvoices = async () => {
    const response = await getMeInvoices();
    const rawInvoices = response.data;

    if (!rawInvoices || !Array.isArray(rawInvoices)) {
        console.warn("[SubscriptionService] getInvoices: API did not return a valid data array.", response);
        return { data: [] };
    }

    const mappedInvoices = rawInvoices.map(inv => ({
        id: inv.invoiceId,
        date: timestampToDate(inv.date),
        plan: inv.planName || 'Fatura',
        value: centToReal(inv.amount),
        status: invoiceStatusMap[inv.status] || 'pending',
        pdfUrl: inv.pdfUrl
    }));

    return { data: mappedInvoices };
}
